export const NOTIFICATION_TYPES = {
  DEFAULT: 'DEFAULT',
  INFO: 'INFO',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
  WARNING: 'WARNING'
};
